export const targetApiConfig = {
  adobeOrg: '3ADD33055666F1A47F000101@AdobeOrg',
  cookiePrefix: 'AMCV_',
  mboxCookies: 'mbox',
  qaModeData: 'at_qa_mode',
}
